const isDefined = require('mn-utils/isDefined');
export const viewport$ = require('mn-utils/browser/emitters/viewport');

export const MOBILE_WIDTH = 986;

export const mobile$ = viewport$
  .map((v) => {
    // console.log(v);
    return isDefined(window.orientation)
      || v[0] < MOBILE_WIDTH
      // || v[1] < MOBILE_WIDTH
  });